import { apiClient } from './client';
import type { ApiResponse } from '@/types';

// ─── Búsqueda global (G-02) ──────────────────────────────────
// Contrato backend: GET /api/busqueda?q=<texto>&limite=<n>  (nivel N1)
// Definido en backend/src/index.ts → busquedaGlobal() (notificaciones.service.ts)
// Devuelve filas de `notificaciones` que coinciden con el texto (LIKE sobre mensaje),
// ya filtradas por rol/nivel del usuario en el backend.
export interface ResultadoBusqueda {
  id: number;
  tipo: string;
  modulo: string;
  referencia_id: number;
  mensaje: string;
  proyecto_id: number | null;
  creado_por: number | null;
  creado_en: string;
  leida: boolean;
}

export const buscarGlobal = (q: string, limite = 8) =>
  apiClient
    .get<ApiResponse<ResultadoBusqueda[]>>('/busqueda', { params: { q, limite } })
    .then((r) => r.data.data);
